/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ChatMessageDTO,
  ConversationDTO,
  CreateChatMessageDTO,
  ErrorResponse,
  UnreadCountDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class ConversationApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Streams the binary data of a chat message attachment.
   *
   * @tags conversation-api
   * @name DownloadAttachment
   * @summary Download a message attachment
   * @request GET:/api/requests/{requestId}/conversation/chats/{chatId}/attachments/{attachmentId}
   * @secure
   */
  downloadAttachment = (
    requestId: number,
    chatId: number,
    attachmentId: number,
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse | string>({
      path: `/api/requests/${requestId}/conversation/chats/${chatId}/attachments/${attachmentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns all chats visible to the current user with their timeline (messages + status pills). Returns 204 when no conversation exists for the request — either the request is still in DRAFT/CREATED state (not yet published), or the request is in a terminal status (CANCELLED/DEACTIVATED) and was closed before any supplier had triggered the conversation. After publish, requester chats (SYSTEM) are always present; supplier chats (ONE_TO_ONE + SYSTEM) are added lazily on the first GET by the supplier, provided the request is not in a terminal status. For legacy active requests that were published before the conversation feature was deployed, the requester SYSTEM chat is lazily backfilled on the first non-operator access.
   *
   * @tags conversation-api
   * @name GetConversation
   * @summary Get the conversation for a request
   * @request GET:/api/requests/{requestId}/conversation
   * @secure
   */
  getConversation = (requestId: number, params: RequestParams = {}) =>
    this.request<ConversationDTO, ErrorResponse | ConversationDTO>({
      path: `/api/requests/${requestId}/conversation`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns the unread count per chat type and in total. Lightweight endpoint intended for polling.
   *
   * @tags conversation-api
   * @name GetUnreadCount
   * @summary Get unread message count
   * @request GET:/api/requests/{requestId}/conversation/unread-count
   * @secure
   */
  getUnreadCount = (requestId: number, params: RequestParams = {}) =>
    this.request<UnreadCountDTO, ErrorResponse | UnreadCountDTO>({
      path: `/api/requests/${requestId}/conversation/unread-count`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Records a read receipt for the current company. Idempotent — subsequent calls are no-ops.
   *
   * @tags conversation-api
   * @name MarkRead
   * @summary Mark a chat as read
   * @request POST:/api/requests/{requestId}/conversation/chats/{chatId}/read
   * @secure
   */
  markRead = (requestId: number, chatId: number, params: RequestParams = {}) =>
    this.request<void, ErrorResponse | void>({
      path: `/api/requests/${requestId}/conversation/chats/${chatId}/read`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Posts a user message to the specified chat. Optionally includes 1–5 attachments (each max 10 MB).
   *
   * @tags conversation-api
   * @name PostMessage
   * @summary Post a message to a chat
   * @request POST:/api/requests/{requestId}/conversation/chats/{chatId}/messages
   * @secure
   */
  postMessage = (
    requestId: number,
    chatId: number,
    data: {
      attachments?: File[];
      /** Request body for creating a new chat message */
      message: CreateChatMessageDTO;
    },
    params: RequestParams = {},
  ) =>
    this.request<ChatMessageDTO, ErrorResponse | ChatMessageDTO>({
      path: `/api/requests/${requestId}/conversation/chats/${chatId}/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
}
